import { useEffect, useState } from 'react';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid, Typography, IconButton, gridClasses, Box } from '@mui/material';
import ModalDialog from '../ui/ModalDialog/index';
import { CancelPresentationRounded, DeleteRounded, EditRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import styles from './style';
import Datagrid from '../ui/Datagrid';
import columns from './table_config';
import { renderCell } from '../ui/Datagrid/table_config';
import DeleteConfirmationModal from '../deleteConfirmationModal';
import AddEditPermissionsModal from './AddEditPermissions';
import { useDispatch, useSelector } from 'react-redux';
import { deletePermissions, getPermissions } from '../../store/actions/permissions';
import { REDUX_ACTIONS } from '../../shared/config/constants';

const PermissionsModal = ({
  onCloseClick,
  isOpen,
  data,
  refreshParentDialog
}) => {
  const classes = styles();
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const [deleteRow, setDeleteRow] = useState({
    open: false,
    data: {}
  });
  const [addEditPermissions, setAddEditPermissions] = useState({
    open: false,
    type: '',
    data: {}
  });
  const permissions = useSelector(state => state.permissions);

  useEffect(() => {
    dispatch(getPermissions(data?.permissionId));
    return () => {
      dispatch({
        type: REDUX_ACTIONS.PERMISSIONS_LIST_RESET
      });
    };
  }, []);

  const handleAddPermissions = () => {
    setAddEditPermissions({
      open: true,
      type: 'Add',
      data
    });
  };

  const handleDeletePermissions = (row) => {
    setDeleteRow({
      open: false,
      data: {}
    });
    const payload = {
      permissions: { [row?.email]: row?.permissions },
      source: { collection: data?.collection?.collectionName, _id: data?._id }
    };
    dispatch(deletePermissions(payload, data?.permissionId, refreshParentDialog));
  };

  const closeHandler = () => {
    onCloseClick();
  };

  const getModalTitle = () => {
    return (
        <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs zeroMinWidth fontSize='18px' sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              maxWidth: 275,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              verticalAlign: 'bottom',
            }}
          >
            {data?.name}
          </Box>
          {data?.collection?.label && ` | ${data.collection.label}`}
          {' | Permissions'}
        </Grid>
          <Grid item>
            <IconButton
              onClick={closeHandler}
            >
              <CancelPresentationRounded fontSize='large' />
            </IconButton>
          </Grid>
        </Grid>
    );
  };
  const renderActions = ({
    row
  }) => {
    return (
      <Grid container justifyContent="center">
        <IconButton
          variant="solid"
          onClick={() => {
            setAddEditPermissions({
              open: true,
              type: 'Edit',
              data: {
                ...data,
                ...row
              }
            });
          }}
        >
          <EditRounded />
        </IconButton>
        <IconButton
          variant="solid"
          onClick={() => {
            setDeleteRow({
              open: true,
              data: row
            });
          }}
        >
          <DeleteRounded />
        </IconButton>
      </Grid>
    );
  };

  if (apiRef.current === null) apiRef.current = {};
  return (
    <ModalDialog
      title={getModalTitle()}
      isOpen={isOpen}
      onClose={closeHandler}
      dialogClass={classes.dialogModal}
    >
      <Grid container>
        {permissions?.permissionsData?.details?.creator
          ? (
            <Grid item container>
              <Typography className={classes.creatorText}>
                Creator: {permissions?.permissionsData?.details?.creator}
              </Typography>
            </Grid>
            )
          : null}
        <Box className={classes.customTool}>
          <Box>
          <Typography variant='button' fontWeight='700' onClick={handleAddPermissions}>+ Add</Typography>
          </Box>
          <Box>
          </Box>
        </Box>
        <Grid item xs={12}>
          <Datagrid
            apiRef={apiRef}
            loading={permissions?.loading}
            data={permissions?.data}
            getRowId={(row) => row.email}
            sx={{
              marginLeft: '-6px',
              '.MuiDataGrid-cell': {
                fontSize: '1rem',
                fontWeight: 900
              },
              '.MuiDataGrid-columnHeaderTitle': {
                fontSize: '1rem',
                fontWeight: '900 !important',
              },
              [`& .${gridClasses.cell}`]: {
                py: 1,
              },
            }}
            columns={columns(renderCell, renderActions)}
            disableStickyHeader={false}
            autoHeight={false}
            autoheight
            height={'50vh'}
            pageSize={100}
            toolbar={{
              options: {
                columns: false,
                filters: false,
                density: false,
                export: false
              },
            }}
          />
        </Grid>
      </Grid>
      {addEditPermissions?.open
        ? (
          <AddEditPermissionsModal
            isOpen={addEditPermissions?.open}
            type={addEditPermissions?.type}
            data={addEditPermissions?.data}
            permissionsData={permissions?.data}
            refreshParentDialog={refreshParentDialog}
            onCloseClick={() => {
              setAddEditPermissions({
                open: false,
                type: '',
                data: {}
              });
            }}
          />
          )
        : null}
      {
        deleteRow?.open && <DeleteConfirmationModal
          open={deleteRow?.open}
          handleDelete={handleDeletePermissions}
          handleClose={() => {
            setDeleteRow({
              open: false,
              data: {}
            });
          }}
          deleteRow={deleteRow?.data}
        />
      }
    </ModalDialog>
  );
};
PermissionsModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  data: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  refreshParentDialog: PropTypes.func.isRequired
};
PermissionsModal.defaultProps = {
  data: {}
};
export default PermissionsModal;
